import React from 'react';
import { Header } from './Header';
import { List } from './List';
import { Item } from './Item';

import s from './Data.module.scss';

type Props = {
  kicker?: React.ReactNode;
  title?: React.ReactNode;
  children: React.ReactNode;
};

interface IData extends React.FC<Props> {
  Header: typeof Header;
  List: typeof List;
  Item: typeof Item;
}

const Data: IData = ({ kicker, title, children }: Props) => {
  return (
    <section className={s.data}>
      <div className={s.data__container}>
        <div className={s.data__layout}>
          <header className={s.data__header}>
            {title && <h2 className={s.data__title}>{title}</h2>}
          </header>
          <div className={s.data__content}>{children}</div>
        </div>
      </div>
    </section>
  );
};

Data.Header = Header;
Data.List = List;
Data.Item = Item;

export { Data };
